// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const mantineAlertPropsSchema = z.object({
	title: z.string().optional(),
});
